import React, { Component } from 'react';
import { Navigate } from 'react-router-dom';
import HeaderShop from '../../components/HeaderShop/HeaderShop';
import { GlobalContext } from '../../interfaces/GlobalContext/GlobalContext';
import { ProductType } from '../../interfaces/ProductProperties/ProductPropertiesRelated';
import { UrlPaths } from '../../interfaces/UrlPaths/UrlPaths';
import EndPageProps from './EndPage.props';
import EndPageState from './EndPage.state';

export default class EndPage extends Component<EndPageProps, EndPageState> {
    static contextType = GlobalContext;
    context!: React.ContextType<typeof GlobalContext>;

    constructor(props: EndPageProps) {
        super(props);
        this.state = {
            key: 'value'
        };
    }

    componentDidMount() {
        window.scrollTo(0, 0);
    }

    render(): React.ReactNode {
        if (!this.context.sessionStorageProvider.getProductInformationFromSessionStorage()?.warenkorbData.length) {
            return <Navigate to={UrlPaths.CARTPAGE} />
        }

        return (
            <>
                <HeaderShop fixed={true} />
                <section className="cs-end-page content-section in-viewport">
                    <div className="container">

                        <div className="end-page">
                            <div className="textblock">
                                <h1 className="end-page__title">{this.context.i18nProvider.get('endPage.title')}</h1>
                            </div>
                          
                            <div className="textblock">
                                <h2 className="end-page__subtitle">{this.context.i18nProvider.get('endPage.subtitle')}</h2>
                            </div>
                            <div className={'end-page__next-steps'}>
                                <div className="end-page__next-steps-row row">
                                    {
                                        this.context.utilityProvider.orderWithNewRegistration(this.context.sessionStorageProvider.getCustomerDataFromSessionStorage()) 
                                            && !this.context.utilityProvider.orderHasBuyableProduct(this.context.sessionStorageProvider.getProductInformationFromSessionStorage()?.warenkorbData || [])
                                            && (
                                                this.context.utilityProvider.orderHasTestproduct(this.context.sessionStorageProvider.getProductInformationFromSessionStorage()?.warenkorbData || [])
                                                || this.context.utilityProvider.orderHasPOB(this.context.sessionStorageProvider.getProductInformationFromSessionStorage()?.warenkorbData || [])
                                            ) 
                                            ? <div className="col end-page__col end-page__col--a">
                                                <h3 className="end-page__next-steps-title">
                                                    {this.context.i18nProvider.get('endPage.nextSteps.a.title')}
                                                </h3>
                                                <div className="textblock" dangerouslySetInnerHTML={{
                                                    __html: this.context.i18nProvider.get('endPage.nextSteps.a.text')
                                                        ?.replaceAll('{{email}}', this.context.sessionStorageProvider.getCustomerDataFromSessionStorage().email as string) as string
                                                }}></div>
                                            </div>
                                            : undefined
                                    }
                                    <div className="col end-page__col end-page__col--b">
                                        <h3 className="end-page__next-steps-title">
                                            {this.context.i18nProvider.get('endPage.nextSteps.b.title')}
                                        </h3>
                                        <div className="textblock" dangerouslySetInnerHTML={{
                                            __html: this.context.i18nProvider.get('endPage.nextSteps.b.text')
                                                ?.replaceAll(
                                                    '{{notloggedin}}', 
                                                    this.context.utilityProvider.orderWithNewRegistration(this.context.sessionStorageProvider.getCustomerDataFromSessionStorage())
                                                        ? this.context.i18nProvider.get('endPage.nextSteps.b.replacement.notLoggedIn') as string
                                                        : ''
                                                )
                                                .replaceAll(
                                                    '{{producttypes}}', 
                                                    this.context.utilityProvider.orderHasBuyableProduct(this.context.sessionStorageProvider.getProductInformationFromSessionStorage()?.warenkorbData || []) 
                                                        ? this.context.utilityProvider.orderHasTestproduct(this.context.sessionStorageProvider.getProductInformationFromSessionStorage()?.warenkorbData || [])
                                                            ? this.context.i18nProvider.get('endPage.nextSteps.b.replacement.productTypes.buyAndTestProduct') as string
                                                            : this.context.i18nProvider.get('endPage.nextSteps.b.replacement.productTypes.buyProduct') as string
                                                        : this.context.i18nProvider.get('endPage.nextSteps.b.replacement.productTypes.testProduct') as string
                                                ) as string
                                        }}></div>
                                    </div>
                                    {
                                        this.context.utilityProvider.orderHasBuyableProduct(this.context.sessionStorageProvider.getProductInformationFromSessionStorage()?.warenkorbData || [])
                                            && this.context.utilityProvider.orderHasMoreThanOneUser(this.context.sessionStorageProvider.getProductInformationFromSessionStorage()?.warenkorbData || [])
                                            ? <div className="col end-page__col end-page__col--c">
                                                <h3 className="end-page__next-steps-title">
                                                    {this.context.i18nProvider.get('endPage.nextSteps.c.title')}
                                                </h3>
                                                <div className="textblock" dangerouslySetInnerHTML={{
                                                    __html: this.context.i18nProvider.get('endPage.nextSteps.c.text')
                                                        ?.replaceAll(
                                                            '{{perproduct}}', 
                                                            this.context.utilityProvider.orderHasMoreThanOneBuyableProduct(this.context.sessionStorageProvider.getProductInformationFromSessionStorage()?.warenkorbData || [])
                                                                ? this.context.i18nProvider.get('endPage.nextSteps.c.replacement.perProduct') as string
                                                                : ''
                                                        )
                                                        .replaceAll(
                                                            '{{morethanonelicense}}', 
                                                            this.context.utilityProvider.orderHasMoreThanOneBuyableProduct(this.context.sessionStorageProvider.getProductInformationFromSessionStorage()?.warenkorbData || [])
                                                                ? this.context.i18nProvider.get('endPage.nextSteps.c.replacement.moreThanOneLicense') as string
                                                                : ''
                                                        ) as string
                                                }}></div>
                                            </div>
                                            : undefined
                                    }
                                </div>
                            </div>
                            <div className="end-page__next-steps">
                                <div className="end-page__next-steps-generic">
                                    <div className="textblock" dangerouslySetInnerHTML={{
                                        __html: this.context.i18nProvider.get('endPage.genericText') || ''
                                    }}></div>
                                </div>
                            </div>
                            {
                                this.context.utilityProvider.orderWithDebit(this.context.sessionStorageProvider.getCustomerDataFromSessionStorage()) &&
                                    <div className="end-page__next-steps">
                                        <div className="end-page__next-steps-generic">
                                            <div className="textblock" dangerouslySetInnerHTML={{
                                                __html: this.context.i18nProvider.get('endPage.sepaText') || ''
                                            }}></div>
                                        </div>
                                    </div>
                            }
                            <div className="end-page__footer">
                                <div className="textblock" dangerouslySetInnerHTML={{
                                    __html: this.context.i18nProvider.get('endPage.footerText') || ''
                                }}></div>
                            </div>





                            <div className="end-page__products">
                                <div className="product-teaser">
                                    <h2 className="sr-only">Bestellte Produkte</h2>
                                    <div className="product-teaser__slider row">
                                        {
                                            this.context.sessionStorageProvider.getProductInformationFromSessionStorage()?.warenkorbData
                                                .sort((productA, productB) => {
                                                    if (productA.productType === ProductType.TEST) {
                                                        if (productB.productType === ProductType.TEST) {
                                                            return 0;
                                                        } else {
                                                            return 1;
                                                        }
                                                    } else {
                                                        if (productB.productType === ProductType.TEST) {
                                                            return -1;
                                                        } else {
                                                            return 0;
                                                        }
                                                    }
                                                })
                                                .map((product, index) => {
                                                    return <div className="product-teaser__col col-6 col-md-3 col-lg-2" key={index}>
                                                        <div className="product-card product-card--shadow">
                                                            <div className="product-card__image-container">
                                                                <div className="product-card__image-overlay-wrapper">
                                                                    <img className="product-card__image" 
                                                                        src={product.queryInformation.imageSrc} 
                                                                        alt={product.queryInformation.imageAlt} />
                                                                </div>
                                                            </div>

                                                            <div className="product-card__text">
                                                                <span className="product-card__title" dangerouslySetInnerHTML={{
                                                                    __html: (product.productType === ProductType.TEST && !this.context.globalStates.getDiscountStatusFromProductProperties(product)
                                                                        ? this.context.i18nProvider.get('endPage.titlePrefixForTestProduct') 
                                                                        : (product.productType === ProductType.TEST && this.context.globalStates.getDiscountStatusFromProductProperties(product) 
                                                                            ? this.context.i18nProvider.get('endPage.titlePrefixForTestProductDiscount') 
                                                                            : '')) + product.queryInformation.title
                                                                }}></span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                })
                                        }
                                        <div className="product-teaser__col col-6 col-md-3 col-lg-2" key={'servicepaket'}>
                                            <div className="product-card product-card--shadow">
                                                <div className="product-card__image-container">
                                                    <div className="product-card__image-overlay-wrapper">
                                                        <img className="product-card__image" 
                                                            src={this.context.i18nProvider.get('cartpageServiceItem.imageSrc')} 
                                                            alt={this.context.i18nProvider.get('cartpageServiceItem.imageAlt')} />
                                                    </div>
                                                </div>

                                                <div className="product-card__text">
                                                    <span className="product-card__title">
                                                        {this.context.i18nProvider.get('cartpageServiceItem.title')}
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="product-teaser__arrows">
                                        <div className="product-teaser__arrow-prev"></div>
                                        <div className="product-teaser__arrow-next"></div>
                                    </div>
                                </div>
                            </div>





                        </div>
                    </div>
                </section>
                <section className="cs-cta-button-group content-section">
                    <div className="container">

                        <div className="cta-button-group">
                            <div className="cta-button-group__cta-wrapper--button"
                                dangerouslySetInnerHTML={{
                                    __html:
                                        (this.context.i18nProvider.get(
                                            'endPage.buttons',
                                            { returnObjects: true }
                                        ) as unknown as Array<string>).join()
                                }}></div>
                        </div>
                    </div>
                </section>
            </>
        );
    }
}
